import { useQuery, useSuspenseQuery } from "@tanstack/react-query";

import { ApiClient } from "../api-client";

import type { GetAllSubjectsResponse } from "../generated-api";

type SubjectSearchParams = {
  title?: string;
  archived?: boolean;
};

export const SUBJECTS_QUERY_KEY = ["subjects"];

export const subjectsQueryOptions = (searchParams?: SubjectSearchParams) => ({
  queryKey: [...SUBJECTS_QUERY_KEY, searchParams],
  queryFn: async () => {
    const response = await ApiClient.api.subjectControllerGetAllSubjects({
      page: 1,
      perPage: 100,
      ...(searchParams?.title && { title: searchParams.title }),
      ...(searchParams?.archived !== undefined && {
        archived: String(searchParams.archived),
      }),
    });
    return response.data;
  },
  select: (data: GetAllSubjectsResponse) => data.data,
});

export function useSubjects(searchParams?: SubjectSearchParams) {
  return useQuery(subjectsQueryOptions(searchParams));
}

export function useSubjectsSuspense(searchParams?: SubjectSearchParams) {
  return useSuspenseQuery(subjectsQueryOptions(searchParams));
}
